import * as yup from 'yup';

export const hwCreateSchema = yup.object().shape({
  title: yup.string().required('Required'),
  studentClass: yup.string().required('Required'),
  subject: yup
    .object()
    .shape({
      id: yup.string().required('Required'),
      name: yup.string().required('Required'),
      ruName: yup.string().required('Required'),
    })
    .required('Required'),
});
